import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGoldenGateBridge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGoldenGateBridge"><Path d="M1 15.5H23" stroke="currentColor"/><Path d="M18.5 4C18.5 7.31371 15.5899 10 12 10C8.41015 10 5.5 7.31371 5.5 4" stroke="currentColor"/><Path d="M23 9C20.5147 9 18.5 6.76142 18.5 4" stroke="currentColor"/><Path d="M1 9C3.48528 9 5.5 6.76142 5.5 4" stroke="currentColor"/><Path d="M5.5 5.5V20" stroke="currentColor"/><Path d="M18.5 5.5V20" stroke="currentColor"/><Path d="M12 10V15.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconGoldenGateBridge;
